<template>
  <el-dialog v-dialog-drag :title="title" :visible.sync="showDialog"  width="550px" :destroy-on-close="true" :before-close="cancel">
    <el-form label-width="120px" ref="form" :model="form">
      <el-form-item label="合同名称" prop="contractName">
        <el-input readonly v-model="form.contractName" clearable></el-input>
      </el-form-item>
      <el-form-item label="合同金额" prop="contractAmount">
        <el-input readonly v-model="form.contractAmount" clearable></el-input>
      </el-form-item>
      <el-form-item label="转预付款金额" prop="impairmentAmount">
        <el-input readonly v-model="form.impairmentAmount" clearable></el-input>
      </el-form-item>
      <el-form-item label="转换原因" prop="impairmentRemark">
        <el-input readonly v-model="form.impairmentRemark" clearable></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="cancel">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>

export default {
  name: "ImpairmentInfo",
  props:['showDialog','selectDetail'],
  data(){
    return{
      title:'正式合同转预付款合同信息',
      form:{
        contractName:'',
        contractAmount:'',
        impairmentAmount:'',
        impairmentRemark:''
      },
    }
  },
  mounted() {
  },
  watch: {
    selectDetail:{
      handler(newVal){
        if(newVal&&Object.keys(newVal).length > 0){
          this.form = JSON.parse(JSON.stringify(newVal))
        }
      },
      immediate:true
    },
  },
  methods: {
    cancel(){
      this.$emit('submit','cancel')
    },
  }
}
</script>

<style scoped>

</style>
